import React from 'react';
import Box from 'components/atoms/Box/Box';
import ReactApexChart from 'react-apexcharts';
import { useTheme } from '@material-ui/core';
import { APP_TEXT_SECONDARY } from 'colours';
import PropTypes from 'prop-types';

/**
 * Apex pie chart based on https://apexcharts.com/react-chart-demos/pie-charts/simple-pie-chart/#
 * @param {} props
 */
export default function PieChart(props) {
  const { children, ...rest } = props;
  const theme = useTheme();

  const options = {
    chart: {},
    plotOptions: {},
    dataLabels: {
      enabled: false,
    },
    theme: {
      monochrome: {
        enabled: true,
        color: theme.palette.primary.main,
      },
    },
    legend: {
      show: false,
    },
    tooltip: {
      style: {
        color: APP_TEXT_SECONDARY,
      },
    },
    labels: props.labels,
    ...props.options,
  };

  return (
    <Box>
      <ReactApexChart
        height={100}
        width={100}
        options={options}
        type="pie"
        {...rest}
      >
        {children}
      </ReactApexChart>
    </Box>
  );
}

PieChart.propTypes = {
  series: PropTypes.arrayOf(PropTypes.number),
  labels: PropTypes.arrayOf(PropTypes.string),
};

PieChart.defaultProps = {};
